import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=63b152b8&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=js&"
export * from "./SelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b152b8",
  null
  
)

export default component.exports